/**
 * Questo file contiene il tipo 'formStep'
 * riporta l'enim dei vari step del forum per renderlo piu leggibile
 */

export enum gaCategory {
	pageLoad = "PageLoad",
	moveStep = "MoveStep",
	buttonClick = "ButtonClick",
	search = "Search",
}

export enum gaAction {
	capSearch = "CapSearch",
	addressSearch = "AddressSearch",
}
